import { useTranslation } from "react-i18next"

import type { HostedAgentWizardTab } from "../utils/hosted-agents"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { DialogFooter } from "@/components/ui/dialog"
import { Spinner } from "@/components/ui/spinner"

export function HostedAgentEditorFooter({
  pending,
  nextStep,
  onStep,
  onClose,
  onSave,
}: {
  pending: boolean
  nextStep: { id: string; tabs: HostedAgentWizardTab[] } | null
  onStep: (tab: HostedAgentWizardTab) => void
  onClose: () => void
  onSave: () => void
}) {
  const { t } = useTranslation()
  return (
    <DialogFooter className="pt-4">
      {nextStep && (
        <Button
          disabled={pending}
          type="button"
          variant="outline"
          onClick={() => onStep(nextStep.tabs[0])}
        >
          {t("adminDashboard.hostedAgents.product.next", {
            step: t(`adminDashboard.hostedAgents.product.steps.${nextStep.id}`),
          })}
        </Button>
      )}
      <Button disabled={pending} type="button" variant="outline" onClick={onClose}>
        {t("adminDashboard.hostedAgents.editDialog.cancel")}
      </Button>
      <Button disabled={pending} type="button" onClick={onSave}>
        {pending && <Spinner />}
        {t(`adminDashboard.hostedAgents.editDialog.${pending ? "saving" : "save"}`)}
      </Button>
    </DialogFooter>
  )
}

export function HostedAgentDiscardDialog({
  open,
  onOpenChange,
  onDiscard,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  onDiscard: () => void
}) {
  const { t } = useTranslation()
  const text = (key: string) => t(`adminDashboard.hostedAgents.product.${key}`)
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{text("discardTitle")}</AlertDialogTitle>
          <AlertDialogDescription>{text("discardHelp")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{text("keepEditing")}</AlertDialogCancel>
          <AlertDialogAction onClick={onDiscard}>{text("discard")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
